<div wnlGroup #wnlGroup="wnlGroup">
  <div class="wnl-header">
    <p>
      WNL: No additional pain findings.
    </p>
    <mat-checkbox [checked]="wnlGroup.allWnl" [indeterminate]="wnlGroup.someWnl"
      (change)="wnlGroup.setAllWnl($event.checked)"
      [ngClass]="{'wnl-checked': wnlGroup.allWnl && !wnlGroup.someWnl, 'wnl-indeterminate': wnlGroup.someWnl}">
      All Within Normal Limits
    </mat-checkbox>
  </div>

  <assessment-row title="Pain Rating (1 - 10)">
    <emr-input type="text" width="50%" [control]="formGroup().controls.painRating" />
  </assessment-row>

  <assessment-row title="Pain Scale">
    <emr-input type="text" width="50%" [control]="formGroup().controls.painScale" />
  </assessment-row>

  <assessment-row title="Pain Location">
    <emr-input type="text" width="50%" [control]="formGroup().controls.painLocation" />
  </assessment-row>

  <assessment-row title="Pain Quality">
    <div class="dropdown-container">
      <emr-input type="select" width="50" [control]="formGroup().controls.painQuality" [options]="painQualityOptions" />
    </div>
    @if (formGroup().controls.painQuality.value === 'Other') {
    <emr-input type="text" placeholder="Description of pain" [control]="formGroup().controls.painQualityOther" />
    }
  </assessment-row>

  @if (patient().isObstetric()) {
  <assessment-row title="Intrapartum Pain Assessment">
    <emr-checkbox [control]="formGroup().controls.hasIntrapartumPain" label="Yes"></emr-checkbox>
  </assessment-row>

  @if (formGroup().controls.hasIntrapartumPain.value) {
  <assessment-row title="Analgesia">
    <emr-checkbox [control]="formGroup().controls.hasAnalgesia" label="Yes"></emr-checkbox>
  </assessment-row>

  @if (formGroup().controls.hasAnalgesia.value) {
  <h3>Analgesia</h3>
  <div>
    <assessment-row title="Epidural Present">
      <emr-checkbox [control]="formGroup().controls.hasEpiduralPresent" label=""></emr-checkbox>
    </assessment-row>
    <assessment-row title="Nitrous Oxide">
      <emr-checkbox [control]="formGroup().controls.nitrousOxide" label=""></emr-checkbox>
    </assessment-row>
    <assessment-row title="Opioids">
      <emr-checkbox [control]="formGroup().controls.opioids" label=""></emr-checkbox>
    </assessment-row>
    <assessment-row title="Other">
      <emr-input type="text" [control]="formGroup().controls.analgesiaOther" label=""></emr-input>
    </assessment-row>
  </div>
  <div>
    <h2>Non-Pharmacologic Interventions</h2>
    <assessment-row title="Walking?">
      <emr-checkbox [control]="formGroup().controls.isWalking" label=""></emr-checkbox>
    </assessment-row>
    <assessment-row title="Position Change">
      <emr-input type="text" [control]="formGroup().controls.positionChange"></emr-input>
    </assessment-row>
    <assessment-row title="Birthing Ball?">
      <emr-checkbox [control]="formGroup().controls.hasBirthingBall" label=""></emr-checkbox>
    </assessment-row>
    <assessment-row title="Warm Bath">
      <emr-input type="text" [control]="formGroup().controls.warmBath"></emr-input>
    </assessment-row>
    <assessment-row title="Other">
      <emr-input type="text" [control]="formGroup().controls.nonPharmacologicOther"></emr-input>
    </assessment-row>
  </div>
  }
  }
  }

  <assessment-row title="Other Findings">
    <emr-input type="text" [control]="formGroup().controls.otherFindings" [wnlControl]="'otherFindings'"
      [wnlDefault]="''" [wnlClearValue]="null" />
  </assessment-row>
</div>